import { React, useEffect } from "react";
import PropTypes from "prop-types";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { CardWrapper } from "../Logistics.styled";
import { toast } from "react-toastify";
import { fetchChartData } from "../utils";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";
import { DoughnutChartOptions } from "../../../Constants";
import { useDispatch, useSelector } from "react-redux";
import { setPurchaseChart } from "../LogisticSlice";

function PurchaseCharts({ currentFilter }) {
	/* eslint-disable no-unused-vars */
	const chartInfo = useSelector((state) => state.logistics.purchaseChart.info);
	const totalValue = useSelector(
		(state) => state.logistics.purchaseChart.totalValue
	);
	const isLeasing = currentFilter === "lease";
	const dispatch = useDispatch();

	const chart1Data = {
		labels: ["Leasing", "Apprenticeship finance"],
		datasets: [
			{
				label: "requests",
				data: [chartInfo.totalLease, chartInfo.totalAF],
				backgroundColor: ["#83D695", "#CDCDCD"],
			},
		],
		totalValue: totalValue.chart1,
	};

	const leaseRequests = {
		labels: ["approved", "rejected"],
		datasets: [
			{
				label: "requests",
				data: [chartInfo.approvedLease, chartInfo.rejectedLease],
				backgroundColor: ["#83D695", "#CDCDCD"],
			},
		],
		totalValue: totalValue.chart2,
	};

	const AfRequests = {
		labels: ["approved", "rejected"],
		datasets: [
			{
				label: "requests",
				data: [chartInfo.approvedAF, chartInfo.rejectedAF],
				backgroundColor: ["#006516", "#CDCDCD"],
			},
		],
		totalValue: totalValue.chart2,
	};

	useEffect(() => {
		getChartData();
	}, [isLeasing]);

	const getChartData = async () => {
		try {
			const chartInfo = await fetchChartData("requestsAnalysis");
			if (chartInfo?.result && isLeasing) {
				let result = {
					info: {
						totalLease: chartInfo.result?.totalLease,
						totalAF: chartInfo.result?.totalAF,
						approvedLease: chartInfo.result?.approvedLease,
						approvedAF: chartInfo.result?.approvedAF,
						rejectedLease: chartInfo.result?.rejectedLease,
						rejectedAF: chartInfo.result?.rejectedAF,
					},
					totalValue: {
						chart1: chartInfo.result?.totalLease + chartInfo.result?.totalAF,
						chart2:
							chartInfo.result?.approvedLease + chartInfo.result?.rejectedLease,
					},
				};
				dispatch(setPurchaseChart(result));
			} else {
				let result = {
					info: {
						totalLease: chartInfo.result?.totalLease,
						totalAF: chartInfo.result?.totalAF,
						approvedLease: chartInfo.result?.approvedLease,
						rejectedLease: chartInfo.result?.rejectedLease,
						approvedAF: chartInfo.result?.approvedAF,
						rejectedAF: chartInfo.result?.rejectedAF,
					},
					totalValue: {
						chart1: chartInfo.result?.totalLease + chartInfo.result?.totalAF,
						chart2: chartInfo.result?.approvedAF + chartInfo.result?.rejectedAF,
					},
				};
				dispatch(setPurchaseChart(result));
			}
		} catch (error) {
			console.error(error);
			toast.error("unable to fetch chart data");
		}
	};

	return (
		<CardWrapper>
			<CardLayout type={"Leasing / Apprenticeship Finance"}>
				<ChartCardContent firstcolor='#83D695' secondcolor='#CDCDCD'>
					<DoughnutChart
						totalAmount={totalValue.chart1}
						data={chart1Data}
						options={DoughnutChartOptions}
					/>
					<ChartlabelALT
						firstColorId={"#83D695"}
						firstCaption={"Leasing"}
						firstAmount={chartInfo?.totalLease}
						secondColorId={"#CDCDCD"}
						secondCaption={"Apprenticeship finance"}
						secondAmount={chartInfo?.totalAF}
						totalAmount={totalValue.chart1}
						customLabel={"request(s)"}
					/>
				</ChartCardContent>
			</CardLayout>

			<CardLayout
				type={
					currentFilter === "lease"
						? "Leasing Requests "
						: "Apprenticeship Requests"
				}
			>
				<ChartCardContent firstcolor='#83D695' secondcolor='#CDCDCD'>
					<DoughnutChart
						totalAmount={totalValue.chart2}
						data={isLeasing ? leaseRequests : AfRequests}
						options={DoughnutChartOptions}
					/>
					<ChartlabelALT
						firstColorId={isLeasing ? "#83D695" : "#006516"}
						firstCaption={"Approved"}
						firstAmount={
							isLeasing ? chartInfo?.approvedLease : chartInfo?.approvedAF
						}
						secondColorId={"#CDCDCD"}
						secondCaption={"Rejected"}
						secondAmount={
							isLeasing ? chartInfo?.rejectedLease : chartInfo?.rejectedAF
						}
						totalAmount={totalValue.chart2}
						customLabel={"request"}
					/>
				</ChartCardContent>
			</CardLayout>
		</CardWrapper>
	);
}

PurchaseCharts.propTypes = {
	currentFilter: PropTypes.string,
};

export default PurchaseCharts;
